export { default } from './couponTray'
